// src/constants.js
export const clientLogos = [
  { src: "/aws-certified.png", alt: "AWS Certified" },
  { src: "/microsoft-certified.png", alt: "Microsoft Certified" },
  { src: "/isc2-certified.png", alt: "ISC2 Certified" }
];

export const services = [
  {
    title: "DevSecOps Pipeline Setup",
    description: "Secure CI/CD workflows using Snyk, SonarQube, Checkmarx, and Fortify.",
    icon: "🔒"
  },
  {
    title: "Cloud Security Audits",
    description: "Analyze AWS, Azure, or GCP infrastructure and eliminate vulnerabilities.",
    icon: "🔍"
  },
  {
    title: "Infrastructure Hardening",
    description: "Secure Terraform and Ansible deployments using CIS benchmarks.",
    icon: "🛡️"
  },
  {
    title: "Incident Response Automation",
    description: "Deploy Lambda-based detection and response pipelines with GuardDuty.",
    icon: "⚡"
  },
  {
    title: "Zero Trust Architecture",
    description: "Implement identity-based segmentation and secure access controls.",
    icon: "🌐"
  },
  {
    title: "Kubernetes Hardening",
    description: "Implement NSA/CISA security guidelines for container orchestration",
    icon: "⚓"
  },
  {
    title: "Compliance Automation",
    description: "Auto-remediate HIPAA/GDPR/SOC2 violations in cloud environments",
    icon: "📝"
  },
  {
    title: "Threat Modeling",
    description: "Proactive identification of architectural vulnerabilities using STRIDE",
    icon: "🕵️"
  }
];

export const certifications = [
  "AWS Certified Security – Specialty (SCS-C01)",
  "AWS Certified Solutions Architect – Associate (SAA-C03)",
  "Microsoft Certified: Azure Security Engineer Associate (AZ-500)",
  "ISC2 Certified in Cybersecurity (CC)"
];


export const caseStudies = [
  {
    title: "Fintech Startup",
    result: "Achieved SOC2 compliance in 6 weeks",
    stats: "↓ 92% vulnerabilities",
    description: "Implemented automated security controls across their AWS environment"
  },
  {
    title: "Healthcare SaaS",
    result: "HIPAA-ready infrastructure",
    stats: "100% audit pass rate",
    description: "Designed zero-trust architecture for sensitive patient data"
  }
];
export const testimonials = [
  {
    name: "Ayo T.",
    role: "Startup CTO",
    feedback: "HunterFortress transformed our AWS infrastructure — fast, secure, and audit-ready. Highly recommended!",
    avatar: "👨🏾‍💻"
  },
  {
    name: "Chinedu K.",
    role: "DevOps Lead",
    feedback: "Their incident response automation saved us hours during compliance reviews. Excellent work.",
    avatar: "👨🏾‍🔧"
  },
  {
    name: "Sarah M.",
    role: "Security Analyst",
    feedback: "Impressed by their depth of knowledge. DevSecOps integration was seamless.",
    avatar: "👩🏼‍💼"
  }
];
export const pricingTiers = [
  {
    name: "Starter",
    price: "₦150k – ₦250k",
    price_usd: "$100 – $150", // Approx. $100–$167 (₦150k–₦250k ÷ 1500)
    desc: "Security essentials for small teams and startups",
    features: [
      "Cloud Review",
      "Basic Hardening",
      "Security Report PDF",
      "Email Support (7 days)"
    ]
  },
  {
    name: "Professional",
    price: "₦400k – ₦600k",
    price_usd: "$250 – $400", // Approx. $267–$400 (₦400k–₦600k ÷ 1500)
    desc: "Advanced protection with expert support",
    features: [
      "Full Security Audit",
      "IAM Policy Review",
      "CI/CD Pipeline Scan",
      "Threat Modeling Session",
      "30-Day Priority Support"
    ]
  },
  {
    name: "Enterprise",
    price: "₦1M+",
    price_usd: "$700+", // Approx. $667+ (₦1M ÷ 1500)
    desc: "Compliance-ready enterprise-grade security",
    features: [
      "Full Audit",
      "Compliance Prep",
      "Training Sessions",
      "Ongoing Retainer",
      "Custom SLAs"
    ]
  }
];
